<img (click)="pageRedirect()" class="close-image" src="assets/images/list-close.png" alt="">
<div class="content center-middle-width padding-common div-position">
    <img class="d-flex ml-auto mr-auto img-size" src="assets/images/thread/no-permission.png" alt="">
    <!--span class="permission-text d-flex justify-content-center">There is no permission for you to view the page. Please contact your administrator.</span-->
    <span class="permission-text d-flex justify-content-center">This view is restricted. Contact your administrator for access</span>
</div>
